export const stringIsEmpty = (stringToCheck) => {
    return stringToCheck === undefined ||
        stringToCheck === null ||
        stringToCheck === "" ||
        stringToCheck.trim() === "";
};



